function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 100 60",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), React.createElement("defs", null, React.createElement("rect", {
  id: "a",
  width: "100",
  height: "60",
  rx: "4"
}), React.createElement("path", {
  d: "M24.115 60H96c2.21 0 4-1.787 4-3.995V33.698S73.2 51.868 24.115 60z",
  id: "b"
})), React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#a"
}), React.createElement("rect", {
  stroke: "#E6772F",
  x: ".5",
  y: ".5",
  width: "99",
  height: "59",
  rx: "4"
}), React.createElement("use", {
  fill: "#E6772F",
  xlinkHref: "#b"
}), React.createElement("path", {
  d: "M18.289 29.822c-.751.642-1.707.923-3.235.923h-.634v-7.66h.634c1.528 0 2.447.261 3.235.935.812.697 1.3 1.77 1.3 2.882 0 1.116-.488 2.229-1.3 2.92zm-2.762-8.7h-3.47v11.586h3.45c1.834 0 3.16-.418 4.32-1.34 1.38-1.093 2.198-2.742 2.198-4.45 0-3.42-2.67-5.796-6.498-5.796zm7.587 0h2.353v11.586h-2.353zm8.13 4.441c-1.42-.499-1.835-.83-1.835-1.457 0-.728.742-1.28 1.762-1.28.707 0 1.29.271 1.91.933l1.228-1.542a5.41 5.41 0 00-3.553-1.287c-2.143 0-3.776 1.426-3.776 3.312 0 1.601.759 2.414 2.974 3.185.927.308 1.397.519 1.635.661.472.292.707.71.707 1.194 0 .943-.78 1.635-1.835 1.635-1.123 0-2.031-.538-2.575-1.548l-1.522 1.41c1.088 1.526 2.392 2.208 4.19 2.208 2.45 0 4.177-1.57 4.177-3.806 0-1.843-.8-2.679-3.487-3.618m4.229 1.355c0 3.407 2.795 6.047 6.392 6.047 1.015 0 1.884-.192 2.955-.675v-2.663c-.946.91-1.777 1.27-2.851 1.27-2.377 0-4.061-1.647-4.061-3.995 0-2.22 1.738-3.977 3.957-3.977 1.12 0 1.976.38 2.955 1.303v-2.66c-1.034-.5-1.883-.707-2.906-.707-3.577 0-6.44 2.691-6.44 6.057M63.949 28.9l-3.229-7.778h-2.574L63.278 33h1.266l5.232-11.878h-2.554L63.95 28.9m6.897 3.808h6.696v-1.963H73.21v-3.128h4.168v-1.962H73.21v-2.57h4.333v-1.963h-6.696v11.586m11.307-6.258h-.685v-3.504h.724c1.475 0 2.265.592 2.265 1.72 0 1.16-.79 1.784-2.304 1.784zm4.735-1.91c0-2.169-1.555-3.418-4.28-3.418h-3.507v11.586h2.367V28.05h.307l3.262 4.658h2.904l-3.809-4.883c1.78-.348 2.756-1.512 2.756-3.284z",
  fill: "#1A1919"
}), React.createElement("path", {
  d: "M58.479 26.945c0 3.335-2.824 6.039-6.311 6.039s-6.311-2.704-6.311-6.039c0-3.336 2.824-6.04 6.31-6.04 3.488 0 6.312 2.704 6.312 6.04",
  fill: "#E6772F"
}))));